import request, {
  GET_REQUEST,
  POST_FORM_DATA_REQUEST,
  POST_REQUEST,
  POST_ENCODE_URI_COMPONENT_REQUEST,
} from '@helpers/request';
import { API_HOST_NAME, ISSUER } from '../env';

export const authService = () =>
  request(`${API_HOST_NAME}/auth/login`, {
    method: 'POST',
  });

export const getRolesAfterActiveProfileService = (data) =>
  request(`${API_HOST_NAME}/auth/get-roles-after-active`, {
    method: 'GET',
    headers: {
      Accept: 'application/json, text/plain, */*',
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data,
  });

export const getAgentInfoDataService = () =>
  request(`${API_HOST_NAME}/agent/getAgentInfo`, {
    method: 'GET',
  });

export const refreshTokenService = (data) =>
  request(ISSUER, {
    method: 'POST',
    data,
  });

export const getPersonalDetailAndBusinessInformationDataService = () =>
  request(`${API_HOST_NAME}/agent/e-card/get-personal-and-business-info`, {
    method: 'GET',
  });

export const checkIsHousehold = () =>
  request(`${API_HOST_NAME}/agent/is-household`, {
    method: 'GET',
  });

export const getActiveProfileService = ({ data }) => {
  return POST_ENCODE_URI_COMPONENT_REQUEST(
    `${API_HOST_NAME}/auth/get-activate-profile`,
    data,
  );
};

export const logOutService = () =>
  request(`${API_HOST_NAME}/auth/logout`, {
    method: 'POST',
  });

export const authenticationForgetPasswordService = (payload) =>
  POST_REQUEST(`${API_HOST_NAME}/account/forget-password`, payload, {
    headers: {
      Accept: 'application/json, text/plain, */*',
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });

export const sendOtpForgetPasswordService = (payload) =>
  POST_REQUEST(`${API_HOST_NAME}/pub/forgot/otp/send`, payload, {
    headers: {
      Accept: 'application/json, text/plain, */*',
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });

export const verifyOtpForgetPasswordService = (payload) =>
  POST_REQUEST(`${API_HOST_NAME}/pub/forgot/otp/verify`, payload, {
    headers: {
      Accept: 'application/json, text/plain, */*',
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });

export const resetPasswordService = (payload) =>
  POST_REQUEST(`${API_HOST_NAME}/account/reset-password`, payload, {
    headers: {
      Accept: 'application/json, text/plain, */*',
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });

export const getLovDataService = () =>
  request(`${API_HOST_NAME}/agent/get-lov-by-channel`, {
    method: 'GET',
  });

export const checkAgentNotificationService = () => {
  return request(`${API_HOST_NAME}/agent/check-notification`, {
    method: 'GET',
  });
};

export const trackUsageFunction = (functionName) => {
  return request(
    `${API_HOST_NAME}/sales-portal/usage-tracking/track-function`,
    {
      method: 'POST',
      data: {
        functionName,
      },
    },
  );
};

export const findActiveProductLicensesService = () =>
  request(`${API_HOST_NAME}/agent/find-active-product-licenses`, {
    method: 'GET',
  });

export const searchAgentManagedByAdAndHierarchyService = (
  agentCode,
  category,
  hierarchyType,
) => {
  return GET_REQUEST(
    `${API_HOST_NAME}/agent/search-agent-managed-by-ad-and-hierarchy`,
    {
      agentCode,
      category,
      hierarchyType,
    },
  );
};

export const searchTitleAndBranchByAgentCodeService = (agentCode) => {
  return GET_REQUEST(
    `${API_HOST_NAME}/agent/get-agent-information-by-agent-code`,
    {
      agentCode,
    },
  );
};

export const searchBankBranchSupportedByAdService = () => {
  return GET_REQUEST(
    `${API_HOST_NAME}/agent/search-bank-branch-supported-by-ad`,
  );
};

export const searchTeamAssignmentByAdAndAgentLikeService = (
  adCode,
  agentCode,
  assignmentType,
) => {
  // Mock response

  return GET_REQUEST(
    `${API_HOST_NAME}/agent/search-team-assignment-by-ad-and-agent-like`,
    {
      adCode,
      agentCode,
      assignmentType,
    },
  );
};
